<script setup lang="ts">
import { computed } from 'vue'
import DE from 'country-flag-icons/string/3x2/DE'
import ES from 'country-flag-icons/string/3x2/ES'
import FR from 'country-flag-icons/string/3x2/FR'
import GB from 'country-flag-icons/string/3x2/GB'
import GR from 'country-flag-icons/string/3x2/GR'
import PL from 'country-flag-icons/string/3x2/PL'
import PT from 'country-flag-icons/string/3x2/PT'
import RU from 'country-flag-icons/string/3x2/RU'
import SA from 'country-flag-icons/string/3x2/SA'
import UA from 'country-flag-icons/string/3x2/UA'

const SVG_BY_LOCALE: Record<string, string> = {
  en: GB,
  es: ES,
  fr: FR,
  de: DE,
  uk: UA,
  ru: RU,
  pl: PL,
  pt: PT,
  el: GR,
  ar: SA,
}

const props = withDefaults(
  defineProps<{
    locale: string
    /** sm: compact (menus), md: default */
    size?: 'sm' | 'md'
  }>(),
  { size: 'md' },
)

const boxClass = computed(() =>
  props.size === 'sm' ? 'h-3.5 w-[1.3125rem]' : 'h-4 w-6',
)

const svgHtml = computed(() => {
  const raw = SVG_BY_LOCALE[props.locale]
  if (!raw) return ''
  return raw.replace('<svg', '<svg class="block h-full w-full" focusable="false"')
})
</script>

<template>
  <span
    class="inline-flex shrink-0 overflow-hidden rounded-[2px] shadow-sm ring-1 ring-black/[0.08] dark:ring-white/15"
    :class="boxClass"
    aria-hidden="true"
    v-html="svgHtml"
  />
</template>
